

export const clone = (object) => {
    return object ? JSON.parse(JSON.stringify(object)): null
}